import { StackBreakpointProvider } from '@teamsparta/stack-core';
import Head from 'next/head';

import { LoggingView } from '@/components/common/LoggingView';
import { Meta } from '@/components/common/Meta';
import { env } from '@/lib/utils/env';
import { CommunityTemplate } from '@/pages/community';
import { breakpoints } from '@/styles/themes';

export default function CommunityPage() {
  return (
    <>
      <Head>
        <Meta
          title='개발자 커리어 개척 캠프 항해99 | 커뮤니티'
          author='항해99'
          description='시시콜콜한 개발 문화부터 깊이 있는 기술 토론까지. 항해99 커뮤니티'
          keywords='코딩 부트캠프, 주니어 개발자, 웹개발, 코딩공부, 프로그래밍, 파이썬, 코딩학원, 코딩 스터디, 부트캠프, 개발자, 코딩, 개발자 취업, AWS, 웹서버, 서버, 클라이언트, 자바스크립트, 리액트, React, Spring, 스프링, 앱개발, React Native, 프론트엔드, 백엔드, 풀스택'
          url={`${env.NEXT_PUBLIC_PAGE_URL}/community`}
          thumbnail='/images/community/og.webp'
        />
        <meta
          property='og:title'
          content='개발자 커리어 개척 캠프 항해99 | 커뮤니티'
        />
        <meta
          property='og:description'
          content='시시콜콜한 개발 문화부터 깊이 있는 기술 토론까지. 항해99 커뮤니티'
        />
        <meta property='og:image' content='/images/community/og.webp' />
        <meta
          property='og:url'
          content={`${env.NEXT_PUBLIC_PAGE_URL}/community`}
        />
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content='항해99' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
        <meta property='og:image:type' content='image/webp' />
        <meta
          property='og:image:alt'
          content='개발자 커리어 개척 캠프 항해99 | 커뮤니티'
        />

        <style>{`
        body {
          background-color: rgb(20, 22, 23);
        }
      `}</style>
      </Head>
      <LoggingView logName='hh_community_page_view'>
        <StackBreakpointProvider
          mobile={breakpoints.mobile}
          desktop={breakpoints.largeTablet}
        >
          <CommunityTemplate />
        </StackBreakpointProvider>
      </LoggingView>
    </>
  );
}
